
export { getContentfulClient } from "/app/packages/ui/src/lib/contentful/index.ts"